/**
 * toast.js — emissor de notificações in-app (substitui os alert() nativos).
 * API imperativa simples: toast.success('...'), toast.error('...'), etc.
 * O <ToastHost/> (montado uma vez em index.js) subscreve e renderiza.
 */
const listeners = new Set();
let counter = 0;

export const subscribeToasts = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const emit = (type, message, opts = {}) => {
  const toastObj = { id: ++counter, type, message, duration: opts.duration ?? 4000 };
  listeners.forEach((l) => l(toastObj));
  return toastObj.id;
};

export const toast = {
  success: (m, o) => emit('success', m, o),
  error:   (m, o) => emit('error', m, o),
  info:    (m, o) => emit('info', m, o),
  warning: (m, o) => emit('warning', m, o),
};

export default toast;
